// extracted by mini-css-extract-plugin
export default {"list__item":"FAQ_list__item__uvvnb","title":"FAQ_title__7QzVq","text":"FAQ_text__8Y0m1"};